import { Link, Typography } from '@mui/material'
import { useState } from 'react'
import ZButton from '../components/ZButton'
import ZIcon from '../components/ZIcon'
import ZBottomContainer from '../components/ZBottomContainer'
import SkipAppropriatenessAssessment from './SkipAppropriatenessAssessment'
import ZScreenContainer from '../components/ZScreenContainer'
import Header from '../components/Header'
import {
  PreAppropriatenessAssessmentReferredIcon,
  PreAppropriatenessAssessmentIcon,
} from '../assets/icons'

const ATTEMPT_WORDS: Record<number, string> = {
  4: 'four',
  5: 'five',
  6: 'six',
  7: 'seven',
}

const PreAppropriatenessAssessment = ({
  onDecision,
  referred,
  orgName,
  knowledgeHubUrl,
  maxAttempts,
}: {
  onDecision: (proceed: boolean) => void
  referred: boolean
  /** Brand name of the app the user came from (e.g. "Zumo", "WEEX"). */
  orgName: string
  knowledgeHubUrl: string
  maxAttempts: number | null
}) => {
  const isReferred = referred

  const [skipAssessment, setSkipAssessment] = useState<boolean>()

  if (skipAssessment) {
    return <SkipAppropriatenessAssessment onDecision={onDecision} />
  }

  const maxAttemptsWord =
    maxAttempts != null
      ? (ATTEMPT_WORDS[maxAttempts] ?? String(maxAttempts))
      : null

  // Shared copy for every org: only the app name changes. Zumo stays named as
  // the regulated firm because it is the principal for all partner apps.
  const body = (
    <>
      Before you start trading, we need to check you understand the key risks.
      <br />
      <br />
      {orgName} is the app you use to trade crypto. Zumo is the FCA-registered
      firm behind the service, responsible for ensuring it meets UK financial
      promotion rules. Neither manages your investments or vets tokens on your
      behalf - this is an execution-only service.
      <br />
      <br />
      To help you prepare, you can review our{' '}
      <Link href={knowledgeHubUrl} underline="none" target="_blank">
        cryptoasset knowledge guide
      </Link>
      . We&apos;ll then ask you a short set of questions.{' '}
      {maxAttemptsWord
        ? `If you don't pass on your first attempt, you can retake the assessment up to ${maxAttemptsWord} times.`
        : "If you don't pass on your first attempt, you can retake the assessment."}
    </>
  )

  return (
    <ZScreenContainer>
      <Header
        title={
          isReferred
            ? 'Self Categorisation Submission'
            : 'Appropriateness Assessment'
        }
      />

      <ZIcon
        Icon={
          isReferred
            ? PreAppropriatenessAssessmentReferredIcon
            : PreAppropriatenessAssessmentIcon
        }
        title="Pre appropriateness assessment icon"
        style={{ alignSelf: 'center' }}
      />

      <Typography>
        {isReferred ? (
          <>
            Thank you for completing the self categorisation. We will be in
            contact with you shortly to verify the details submitted.
            <br />
            <br />
          </>
        ) : null}
        {body}
      </Typography>

      <ZBottomContainer>
        <ZButton onClick={() => onDecision(true)}>Start the assessment</ZButton>

        <ZButton onClick={() => setSkipAssessment(true)}>
          I&apos;ll do this later
        </ZButton>
      </ZBottomContainer>
    </ZScreenContainer>
  )
}

export default PreAppropriatenessAssessment
